<template>
  <ol class="ranking-list">
    <li
      v-for="(content, index) in filterRunner(dataRanking.contents)"
      :key="index"
      class="ranking-list__item"
    >
      <!-- ランキング --- : 割り込みランキング -->
      <div v-if="content.total_ranking === '99999999'" class="rank">
        <span>---</span>
      </div>
      <!-- 累積イベント && 暫定(status === '0') && DNFの人 -->
      <div
        v-else-if="
          (dataEventRanking.text.accumulation_flag &&
            eventStatus === '0' &&
            content.ranking === 'DNF') ||
          (Number(distanceLimitFlg) === 0 && eventStatus === '0')
        "
        class="rank"
      >
        <img src="../../../assets/images/ranking/runner.svg" alt="" />
      </div>
      <div v-else-if="content.total_ranking === '1'" class="rank">
        <img src="../../../assets/images/ranking/1st-place.svg" alt="1" />
      </div>
      <div v-else-if="content.total_ranking === '2'" class="rank">
        <img src="../../../assets/images/ranking/2nd-place.svg" alt="2" />
      </div>
      <div v-else-if="content.total_ranking === '3'" class="rank">
        <img src="../../../assets/images/ranking/3rd-place.svg" alt="3" />
      </div>
      <div v-else class="rank">{{ content.total_ranking }}</div>
      <div class="user-info">
        <div class="name">{{ content.runner_name }}</div>
        <div class="entry-id">{{ content.entry_id }}</div>
        <div class="time">{{ displayTimeOrDistance(content) }}</div>
        <div class="detail">
          <template
            v-for="(ranking_item, index) of dataEventSummary.ranking_items"
          >
            <div class="gender" v-if="ranking_item === '性別'" :key="index">{{
              content.gender[lang]
            }}</div>
            <div class="age" v-if="ranking_item === '年代'" :key="index">{{
              content.age
            }}</div>
            <!-- 特別対応 2021/03/01 既存APIと束ねAPIでレスポンスに差分があるため -->
            <div
              class="area"
              v-if="isForeignCountry && ranking_item === '居住地'"
              :key="index"
              >{{ content.country_name }}</div
            >
            <div
              class="area"
              v-else-if="!isForeignCountry && ranking_item === '居住地'"
              :key="index"
              >{{ content.area_name[lang] }}</div
            >
            <div
              class="department"
              v-if="ranking_item === '部署'"
              :key="index"
              >{{ content.department }}</div
            >
            <div class="branch" v-if="ranking_item === '支店'" :key="index">{{
              content.branch
            }}</div>
            <div
              class="affiliation"
              v-if="ranking_item === '所属'"
              :key="index"
              >{{ content.affiliation }}</div
            >
          </template>
        </div>
      </div>
      <!-- ランキング99999999位 : 割り込みランキング -->
      <a
        href="https://tmf-virtualrun.jp/pdf/certificate/2020/RaO/1200239.pdf"
        class="certificate flex-all-center"
        v-if="content.total_ranking === '99999999'"
      >
        <figure class="certificate__figure">
          <img
            src="../../../assets/images/certificate/certificate.svg"
            width="13"
            alt=""
          />
          <figcaption class="completion-fig">
            {{ Ranking.certificate[lang] }}
          </figcaption>
        </figure>
      </a>
      <!-- 累積イベント && DNFの人 : 距離を表示 -->
      <dl
        class="run-log"
        v-else-if="
          (dataEventRanking.text.accumulation_flag &&
            content.ranking === 'DNF') ||
          (Number(distanceLimitFlg) === 0 && eventStatus === '0')
        "
      >
        <dt class="run-log__dt">{{ Ranking.runLog[lang] }}</dt>
        <dd class="run-log__dd">{{ content.distance }}</dd>
      </dl>
      <!-- 確定時 && 完走者 : 完走証へのリンク -->
      <router-link
        :to="{
          path: `/${langPath}${
            $route.path.includes('company') ? 'company/' : ''
          }ranking/certificate`,
          query: {
            event: nassEventId,
            runner: content.id,
          },
        }"
        class="certificate flex-all-center"
        v-else-if="
          eventStatus === '100' &&
          content.ranking !== 'DNS' &&
          content.ranking !== 'DNF'
        "
      >
        <figure class="certificate__figure">
          <img
            src="../../../assets/images/certificate/certificate.svg"
            width="13"
            alt=""
          />
          <figcaption class="completion-fig">
            {{ Ranking.certificate[lang] }}
          </figcaption>
        </figure>
      </router-link>
    </li>
  </ol>
</template>

<script>
export default {
  methods: {
    filterRunner: function (rankingContents) {
      return rankingContents.filter(
        (runner) => this.eventStatus === "100" || runner.ranking !== "DNS"
      );
    },
    displayTimeOrDistance: function (content) {
      if (
        this.eventStatus === "100" &&
        Number(this.distanceLimitFlg) === 0 &&
        content.distance
      ) {
        return content.distance;
      }
      return content.result_time;
    },
    displayTimeOrDistanceHeader: function () {
      if (this.eventStatus === "100" && Number(this.distanceLimitFlg) === 0) {
        return this.Ranking.distance[this.lang];
      }
      return this.Ranking.time[this.lang];
    },
  },
  props: {
    lang: String,
    langPath: String,
    Ranking: Object,
    dataEventRanking: Object,
    dataEventSummary: Object,
    dataRanking: Object,
    eventStatus: String,
    isForeignCountry: Boolean,
    nassEventId: String,
    distanceLimitFlg: [String, Number],
  },
  created() {
    // VMGCイベント向け暫定
    if (this.nassEventId === "0000000057") {
      this.dataEventRanking.text.accumulation_flag = true;
    }
  },
  name: "RankingList",
};
</script>

<style scoped>
.ranking-list {
  .ranking-list__item {
    display: flex;
    padding: 15px 0;
    border-bottom: solid 1px var(--grayColor2);
    .rank {
      min-width: 40px;
      margin: 0 16px 0 0;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
    }
    .user-info {
      flex: 1;
      line-height: 1;
      margin: 0 24px 0 0;
      .name {
        margin: 6px 0 0 0;
        line-height: 1.2;
        font-size: 20px;
        font-weight: bold;
      }
      .entry-id {
        margin: 6px 0 0 0;
        font-size: 14px;
      }
      .time {
        margin: 6px 0 0 0;
        font-size: 16px;
        font-weight: bold;
      }
      .detail {
        display: flex;
        margin: 12px 0 0 0;
        font-size: 14px;
        .gender::after,
        .age::after,
        .area::after,
        .department::after,
        .branch::after,
        .affiliation::after {
          content: ",";
          margin: 0 4px;
        }
        @media screen and (max-width: 350px) {
          font-size: 12px;
        }
      }
    }
    .certificate {
      width: 70px;
      height: 103px;
      font-size: 10px;
      border: solid 1px var(--defaultBlackColor);
      background-color: var(--defaultWhiteColor);
      &__figure {
        text-align: center;
        .completion-fig {
          margin: 7px 0 0 0;
        }
      }
    }
    .run-log {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 70px;
      height: 72px;
      background-color: var(--defaultGrayColor);
      &__dt {
        font-size: 12px;
        font-weight: normal;
      }
      &__dd {
        margin: 6px 0 0 0;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/ranking/RankingList.vue